import { uniqBy } from 'lodash';
import List from '@common/lib/List';
import { getPaymentTypes, ChargesBy } from 'pando-constants';

const mutation = {
  initialReset(state) {
    state.list = [];
    state.invoicelist = [];
    state.filter = {};
    state.filter.page_number = 1;
    state.filter.page_limit = 20;
    state.hasEmpty = true;
    state.indentDetails = [];
    state.invoiceDetails = [];
    state.isLoading = false;
    state.isUploading = false;
  },

  setSelectedPaymentsList(state, data) {
    state.selectedPaymentsList = data;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page_number > 1) ? state.list.concat(data) : data;
    state.list = uniqBy(result, 'id');
    if (data.length) {
      state.filter.page_number += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  updatePayments(state, data) {
    state.list = List.update(state.list, data);
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_INVOICE(state, data) {
    const result = (state.filter.page_number > 1) ? state.invoicelist.concat(data) : data;
    state.invoicelist = result;
    if (data.length) {
      state.filter.page_number += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  setUploading(state, data) {
    state.isUploading = data;
  },

  setRejected(state, data) {
    state.isRejected = data;
  },

  setUploadResponse(state, data) {
    state.uploadResponse = data;
  },

  setPage(state, page) {
    state.filter.page_number = page;
  },

  setTempCharges(state, data) {
    state.tempCharges = data;
  },
  updateTempCharges(state, data) {
    const obj = {};
    obj[data.index] = { ...state.tempCharges[data.index], ...data.value };
    state.tempCharges = { ...state.tempCharges, ...obj };
  },
  updateIndentDetailCharges(state, data) {
    const payments = state.invoiceDetails.payments || state.indentDetails;
    const paymentData = payments
      .find(payment => payment.id === data.id);
    const consigneeData = paymentData.consignee_data
      .find(consignee => consignee.id === data.consigneeId);
    const charges = consigneeData.charges
      .find(charge => charge.charges_by === ChargesBy.TRANSPORTER);
    let difference = 0;
    if (data.charges.total_amount) {
      difference = data.charges.total_amount - charges.total_amount;
    }
    Object.keys(data.charges).forEach((charge) => {
      charges[charge] = data.charges[charge];
    });
    state.totalTransporterCharges += difference;
    state.transporterTotalFreightCharge = charges.contract_charge;
  },
  clearTempCharges(state) {
    state.tempCharges = {};
  },

  setIndentDetails(state, payload) {
    const { data, params } = payload;
    const depotDetails = state.depotWiseDetails && state.depotWiseDetails[params.depot_id];
    if (params.page_number === depotDetails.page_number) {
      if (data.length) {
        const result = (state.filter.page_number > 1) ? state.indentDetails.concat(data) : data;
        state.indentDetails = result;
        state.filter.page_number += 1;
        state.hasEmpty = false;
      } else {
        state.hasEmpty = true;
      }
    }
  },

  updateDepotPagination(state, params) {
    const { depot_id: depotId, payment_count: paymentCount } = params;
    const depotWiseDetails = state.depotWiseDetails;
    if (depotWiseDetails[depotId] && depotWiseDetails[depotId].page_number === params.page_number) {
      depotWiseDetails[depotId].page_number += 1;
      depotWiseDetails[depotId].loaded_payments += paymentCount;
      if (!paymentCount) {
        depotWiseDetails[depotId].has_empty = true;
      }
    }
    state.depotWiseDetails = depotWiseDetails;
  },

  clearDepotDetails(state, data) {
    state.depotWiseDetails = data;
  },

  updateIndentDetails(state, data) {
    state.indentDetails = List.update(state.indentDetails, data);
  },

  replaceIndentDetails(state, data) {
    state.indentDetails = data;
  },

  replaceInvoiceDetails(state, data) {
    state.invoiceDetails = data;
  },

  addInvoiceComment(state, data) {
    const index = state.list.findIndex(invoice => invoice.id === data.id);
    if (index > 0) {
      state.list[index].comments.push(data.comment);
    }
  },

  setInvoiceDetails(state, data) {
    const { params } = data;
    const depotDetails = state.depotWiseDetails && state.depotWiseDetails[params.depot_id];
    if (params.page_number === depotDetails.page_number) {
      if (data.data.payments && data.data.payments.length) {
        if (state.invoiceDetails && state.invoiceDetails.data) {
          data.data.sez_enabled = state.invoiceDetails.data.sez_enabled
              && data.data.sez_enabled;
        }
        const result = (state.filter.page_number > 1) ?
          state.invoiceDetails.payments.concat(data.data.payments) : data.data.payments;
        state.invoiceDetails = data;
        state.invoiceDetails.payments = result;
        // state.indentDetails = result;
        state.filter.page_number += 1;
        state.hasEmpty = false;
      } else {
        state.hasEmpty = true;
      }
    }
  },

  setTotalSystemCharges(state, data) {
    state.totalSystemCharges = data;
  },

  setTotalTransporterCharges(state, data) {
    state.totalTransporterCharges = data;
  },
  setInvoiceAmount(state, amount) {
    if (state.invoiceDetails && state.invoiceDetails.data) {
      state.invoiceDetails.data.invoice_amount = amount;
    }
  },

  setTansporterTotalFreightCharge(state, data) {
    state.transporterTotalFreightCharge = data;
  },

  setHasEmpty(state, data) {
    state.hasEmpty = data;
  },

  setDedicatedTruckMaster(state, data) {
    state.dedicatedTruckMaster = data;
  },
  setFreightBillDetails(state, data) {
    state.freightBillDetails = data;
  },
  setDepotDetails(state, data) {
    if (data && data.depot_details) {
      const depotDetail = data.depot_details
      const depotCharges = data.depot_wise_charges
      state.depotWiseDetails = Object.keys(depotDetail).reduce((acc, depot) => {
        acc[depot] = {
          ...depotDetail[depot],
          page_number: 1,
          loaded_payments: 0,
          has_empty: false,
        };
        if(depotCharges && depotCharges[depot]){
          acc[depot].depot_total = depotCharges[depot][0].total
        }
        return acc;
      }, {});
    }
  },
  setPaymentMovements(state, data) {
    state.paymentMovements = data;
  },
  setFreightBillCategories(state, data) {
    state.freightBillCategories = data;
  },
  setTotalIndentCount(state, data) {
    state.totalIndentCount = data;
  },
  setProformaInvoiceNumber(state, data) {
    state.proformaInvoiceNumber = data;
  },
  setIsDedicatedTruck(state, data) {
    let currResult = false;
    if (data.data.payments && data.data.payments.length) {
      currResult = data.data.payments.every(payment => payment.type ===
        getPaymentTypes().DEDICATED_TRUCK_WITH_INDENT_PAYMENT);
    }
    if (state.isDedicatedTruck === null) {
      state.isDedicatedTruck = currResult;
    } else {
      state.isDedicatedTruck = state.isDedicatedTruck && currResult;
    }
  },
  updateSignatureStatus(state, data) {
    const index = state.list.findIndex(invoice => invoice.id === data.invoiceId);
    if (index !== -1) {
      state.list[index].invoice_signature_status = data.status;
    }
  },
  setInvoiceApprovalSettings(state, data) {
    state.invoiceApprovalSettings = data;
  },
  setInvoiceLevelApprovalSettings(state, data) {
    state.invoiceLevelApprovalSettings = data;
  },
  setSelectedLegalEntity(state, data) {
    state.selectedLegalEntity = data;
  },
  setIsShipperChargesFeatureEnabled(state, value) {
    state.isShipperChargesFeatureEnabled = value;
  },
};

export default mutation;
